var _style, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicateCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "127px",
    viewBox: "0 0 128 127",
    style: {
      enableBackground: "new 0 0 128 127"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#00B929;stroke-width:8;}\n\t.st1{fill:#00B929;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 64,
    cy: 63.2,
    rx: 60,
    ry: 58.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,33.8H44.1c-3.2,0-5.8,2.6-5.8,5.8v37.7h6.4V40.1h31.9V33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.9,44.4H54.7c-3.2,0-5.8,2.6-5.8,5.8v37.2c0,3.2,2.6,5.8,5.8,5.8h29.2c3.2,0,5.8-2.6,5.8-5.8V50.2 C89.8,47,87.1,44.4,83.9,44.4z M83.4,50.8v36.1H55.2V50.8H83.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateCircle);
export default __webpack_public_path__ + "static/media/duplicate_circle.4a8023c88e8ba527064bcb1a014e9267.svg";
export { ForwardRef as ReactComponent };